import * as _ from 'lodash';

import * as angular from 'angular';

import Colors from '../../core/styleguide/colors.service';

import BuyerOfferImpactService from './buyerOfferImpact.service';
import { Puck } from './../../impact/impact.type';

interface MemberSummary {
  id: number;
  name: string;
  combinedMarketShare: number;
  memberPlanId: number;
  sellerImpacts: any;
}

class ImpactOverviewForBuyerCtrl {
  static bindings = {
    activeSeller: '<',
    members: '<'
    // sellerImpacts: '<'
  };

  activeSeller;
  members: MemberSummary[];

  // // We use this to track when the members list updates so we can re-calculate numbers
  cachedMembers;

  // This is the list we actually use to calculate the numbers
  // This is generated from the list of members for the active seller when they update
  sellerImpacts: any;

  aptitudePositiveColor = this.colors.aptGreen;
  aptitudeNegativeColor = this.colors.aptOrange;
  lightgray = '#d3d3d3';

  notSavingDial = {
    percentage: 0,
    number: 0,
    color: this.aptitudeNegativeColor,
    notColor: '',
    label: ''
  };

  potentialMarketShareDial = {
    percentage: 0,
    number: 0,
    numberIsPercentage: true,
    label: '',
    color: this.aptitudeNegativeColor
  };

  in = {
    count: 0,
    savings: 0,
    spend: 0,
    gauge: 0,
    potentialSpend: 0
  };

  out = {
    count: 0,
    savings: 0,
    spend: 0,
    gauge: 0
  };

  undecided = {
    count: 0,
    savings: 0,
    spend: 0,
    gauge: 0
  };

  notSavingCount = 0;

  total = {
    count: 0,
    spend: 0,
    savings: 0
  };

  constructor(
    private colors: Colors,
    private BuyerOfferImpact: BuyerOfferImpactService
  ) {
    'ngInject';
  }

  // This handles the initial load
  $onChanges(changes) {
    if (changes.activeSeller || changes.members) {
      if (this.members && this.activeSeller) {
        this.sellerImpacts = this.BuyerOfferImpact.getSellerImpacts(
          this.members,
          this.activeSeller
        );
        this.updateCounts();
      }
    }
  }

  // $onChanges (changes) {
  //   if (changes.sellerImpacts) {
  //       this.updateCounts();
  //   }
  // }

  /**
   * Any time the data for a member is updated, update the overview with the new data
   */
  $doCheck() {
    if (!angular.equals(this.cachedMembers, this.members)) {
      // console.log('Buyer Overview: Members updated.');

      this.cachedMembers = angular.copy(this.members);

      this.sellerImpacts = this.BuyerOfferImpact.getSellerImpacts(
        this.members,
        this.activeSeller
      );
      this.updateCounts();
    }
  }

  updateCounts() {
    if (!this.sellerImpacts) {
      return false;
    }

    let inMembers = _.filter(this.sellerImpacts, {
      inclusionStatus: 'In'
    });

    let outMembers = _.filter(this.sellerImpacts, {
      inclusionStatus: 'Out'
    });

    let undecidedMembers = _.filter(this.sellerImpacts, {
      inclusionStatus: 'Undecided'
    });

    this.updateMemberCounts(this.in, inMembers);
    this.updateMemberCounts(this.out, outMembers);
    this.updateMemberCounts(this.undecided, undecidedMembers);
    this.updateMemberCounts(this.total, this.sellerImpacts);

    // Total potential spend for In members
    this.in.potentialSpend = _.sumBy(inMembers, 'potentialSpend');

    let notSavingMembers = _.filter(this.sellerImpacts, (impact: Puck) => {
      return impact.savings < 0;
    });

    this.notSavingCount = notSavingMembers.length;

    this.updateBarGauges();
    this.updateNotSavingDial();
    this.updatePotentialMarketShareDial();
  }

  updateMemberCounts(obj, sellerImpacts) {
    if (!sellerImpacts || sellerImpacts.length == 0) {
      obj.count = 0;
      obj.savings = 0;
      obj.spend = 0;

      return false;
    }

    obj.count = sellerImpacts.length;
    obj.savings = _.sumBy(sellerImpacts, 'savings');
    obj.spend = _.sumBy(sellerImpacts, 'plannedSpend');
  }

  updateBarGauges() {
    this.in.gauge = this.BuyerOfferImpact.percentOrZero(
      this.in.count,
      this.total.count
    );
    this.undecided.gauge = this.BuyerOfferImpact.percentOrZero(
      this.undecided.count,
      this.total.count
    );
    this.out.gauge = this.BuyerOfferImpact.percentOrZero(
      this.out.count,
      this.total.count
    );
  }

  updateNotSavingDial() {
    this.notSavingDial.number = this.notSavingCount;
    this.notSavingDial.percentage = this.BuyerOfferImpact.percentOrZero(
      this.notSavingCount,
      this.total.count
    );
    this.notSavingDial.label = 'of ' + this.total.count;

    if (this.notSavingDial.percentage === 0) {
      this.notSavingDial.notColor = this.aptitudePositiveColor;
      this.notSavingDial.color = this.aptitudePositiveColor;
    } else {
      this.notSavingDial.notColor = this.lightgray;
      this.notSavingDial.color = this.aptitudeNegativeColor;
    }
  }

  updatePotentialMarketShareDial() {
    var potentialMarketShare = this.BuyerOfferImpact.percentOrZero(
      this.in.spend,
      this.in.potentialSpend
    );
    this.potentialMarketShareDial.percentage = potentialMarketShare;
    this.potentialMarketShareDial.number = potentialMarketShare;

    if (potentialMarketShare >= this.activeSeller.targetMarketShare) {
      this.potentialMarketShareDial.color = this.aptitudePositiveColor;
    } else {
      this.potentialMarketShareDial.color = this.aptitudeNegativeColor;
    }
  }

  // totalSavings () {
  //   if (this.in.savings != null) {
  //     return this.in.savings + this.out.savings + this.undecided.savings;
  //   } else {
  //     return 0;
  //   }
  // }

  // totalInOutUndecidedSpend (dataSet) {
  //   if (this.in.spend != null) {
  //     this.in.spend + this.out.spend + this.undecided.spend;
  //   } else {
  //     return 0;
  //   }
  // }
}

export const ImpactOverviewForBuyerComponent = {
  template: require('./impactOverviewForBuyer.component.html'),
  controller: ImpactOverviewForBuyerCtrl,
  bindings: ImpactOverviewForBuyerCtrl.bindings
};
